// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3596":"subscription","3715":"list","7962":"home","9702":"story"}[chunkId] || chunkId) + "-" + {"3596":"7e0ff40293a57ce2bf6b","3715":"104cf1586453665efacc","7539":"239b3113388310ad8fda","7962":"f5394bcf05fb8faf17a8","9702":"92710e1988944b43ccdc"}[chunkId] + ".css";
};